import styled from 'styled-components'

interface IFormattedTimeStyledProps {}

export const FormattedTimeStyled = styled.span<IFormattedTimeStyledProps>`
  white-space: nowrap;
`
